// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__D8uWi","gfeWrapper":"CalendarEvent_gfeWrapper__kwmvE"};